var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"pl_0 odd_margin strong"},[_c('span',{class:{ colorClass: _vm.colorClass, border_left: _vm.value }},[_vm._v(_vm._s(_vm.value || ''))])])}
var staticRenderFns = []

export { render, staticRenderFns }